import {config} from '@config'

import {easing} from '@helpers/easing'

export class HoverImages {

  private rotate = 0
  private lastUpdate = Date.now()
  private imageWidth = 0
  private imageHeight = 0
  private defaultWidth = 225
  private defaultHeight = 150

  private translateX = 0
  private translateY = 0
  private screenX = 0
  private lastScreenX = 0

  private isEnter = false

  constructor(
    private element: HTMLDivElement,
    private imageContainer: HTMLDivElement,
    private images: HTMLDivElement[],
    private items: HTMLDivElement[],
    private ratio: number = 1
  ) {
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    this.animationFrame = this.animationFrame.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onMouseEnterItem = this.onMouseEnterItem.bind(this)
    this.onMouseLeaveItem = this.onMouseLeaveItem.bind(this)
  }

  public init() {
    this.items.map(item => {
      item.addEventListener('mouseenter', this.onMouseEnterItem)
      item.addEventListener('mouseleave', this.onMouseLeaveItem)
    })
    this.element.addEventListener('mouseenter', this.onMouseEnter)
    this.element.addEventListener('mousemove', this.onMouseMove)
    this.element.addEventListener('mouseleave', this.onMouseLeave)


    this.imageContainer.style.width = `${this.defaultWidth}px`
    this.imageContainer.style.height = `${this.defaultHeight}px`
    this.imageContainer.style.opacity = '0'
    this.imageContainer.style.transition = `all 0.5s ${easing.easeOutCubic}`

    this.hideImages(1)
  }

  public destroy() {
    this.isEnter = false
    this.items.map(item => {
      item.removeEventListener('mouseenter', this.onMouseEnterItem)
      item.removeEventListener('mouseleave', this.onMouseLeaveItem)
    })
    this.element.removeEventListener('mouseenter', this.onMouseEnter)
    this.element.removeEventListener('mousemove', this.onMouseMove)
    this.element.removeEventListener('mousemove', this.animationFrame)
    this.element.removeEventListener('mouseleave', this.onMouseLeave)
  }

  private hideImages(index: number) {
    this.images.map((image, i) => {
      image.style.transition = `all 1.0s ${easing.easeOutCirc}`
      image.style.opacity = index === i ? '1' : '0'
      image.style.transform = `translate(-50%, -50%) scale(${index === i ? 1 : 1.2})`

      const img = image.querySelector('img') as HTMLImageElement
      if (index === i) {
        const {innerWidth} = window
        const ratio = innerWidth / config.defaultViewportWidth
        const resizedImageWidth = img.naturalWidth * ratio
        const resizedImageHeight = img.naturalHeight * ratio
        this.imageWidth = Math.min(img.naturalWidth, resizedImageWidth) / this.ratio
        this.imageHeight = Math.min(img.naturalHeight, resizedImageHeight) / this.ratio
      }
    })
  }

  private onMouseEnterItem(e: MouseEvent) {
    const target = e.target as HTMLDivElement
    const i = target.dataset['index'] || '0'
    const index = parseInt(i, 10) - 1
    this.hideImages(index)
    target.classList.add('active')
  }

  private onMouseLeaveItem(e: MouseEvent) {
    const target = e.target as HTMLDivElement
    target.classList.remove('active')
  }

  private onMouseEnter(e: MouseEvent) {
    const {top, left} = this.element.getBoundingClientRect()
    if (this.imageContainer) {
      this.imageContainer.style.opacity = '1'
      this.imageContainer.style.width = `${this.imageWidth}px`
      this.imageContainer.style.height = `${this.imageHeight}px`

      this.imageContainer.style.transform = `translate(${e.clientX - left - this.imageWidth / 2}px, ${e.clientY - top - this.imageHeight / 2}px)`
    }
    this.screenX = e.screenX
  }

  private onMouseMove(e: MouseEvent) {
    const target = e.currentTarget as HTMLImageElement
    const {top, left} = target.getBoundingClientRect()
    if (this.imageContainer) {
      this.imageContainer.style.width = `${this.imageWidth}px`
      this.imageContainer.style.height = `${this.imageHeight}px`
      this.translateX = e.clientX - left - this.imageWidth / 2
      this.translateY = e.clientY - top - this.imageHeight / 2
    }
    if (!this.isEnter) {
      this.isEnter = true
      this.animationFrame()
    }
    this.screenX = e.screenX
  }

  private animationFrame() {
    const accelerationX = this.screenX - this.lastScreenX

    const now = Date.now()
    const delta = now - this.lastUpdate
    this.lastUpdate = now
    const pullX = accelerationX / 6
    this.rotate = (this.rotate + pullX) * Math.pow(0.99, delta)

    if (this.imageContainer) {

      if (this.isEnter) {
        this.imageContainer.style.transform = `translate(${this.translateX}px, ${this.translateY}px) rotate(${this.rotate}deg)`
      }
    }

    this.lastScreenX = this.screenX
    this.isEnter && window.requestAnimationFrame(this.animationFrame)
  }


  private onMouseLeave(e: MouseEvent) {
    this.isEnter = false

    const {top, left} = this.element.getBoundingClientRect()
    if (this.imageContainer) {
      this.imageContainer.style.opacity = '0'
      this.imageContainer.style.width = `${this.defaultWidth}px`
      this.imageContainer.style.height = `${this.defaultHeight}px`
      this.imageContainer.style.transform = `translate(${e.clientX - left - this.defaultWidth / 2}px, ${e.clientY - top - this.defaultHeight / 2}px)`
    }
  }
}
